import { Descendant } from 'slate';

export function isRichTextEditorEmpty(editorContent: Descendant[]): boolean {
  if (!editorContent) {
    return true;
  }

  return editorContent.every((node: Descendant) => {
    if ('children' in node) {
      // Assuming node.children is an array of nodes
      return node.children.every((child: Descendant) => {
        if ('text' in child) {
          return !child.text.trim();
        }
        return true; // Handle other block types if needed
      });
    }
    return true; // Handle other block types if needed
  });
}

export const isEqualRichTextContents = (obj1: Descendant[], obj2: Descendant[]) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};
